import './ai-analyst-page.css';
import React, { useState } from 'react';
import AIConversation from 'components/organisms/ai-chat/ai-conversation';
import ChatContainer from 'components/organisms/ai-chat/chat-container';

interface ChatInputProps {}

export default function AIAnalystPage({}: ChatInputProps) {
	const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

	return (
		<div className="h-full flex flex-col bg-white relative">
			<div className="flex flex-1 overflow-hidden">
				<div className="md:flex hidden">
					<AIConversation onSidebarCollapsedChange={setSidebarCollapsed} />
				</div>
				<main
		  className={`
			flex-1 transition-all duration-200 
			${sidebarCollapsed ? 'md:w-[calc(100%-0px)]' : ''}
		  `}
		>
		  <ChatContainer sidebarCollapsed={sidebarCollapsed} />
		</main>
			</div>
		</div>
	);
}
